import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { concat } from 'rxjs';
import { reduce, toArray } from 'rxjs/operators';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-add-timeline',
    templateUrl: './add-timeline.component.html',
    styleUrls: ['./add-timeline.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddTimelineComponent implements OnInit {

	@Input() project: any;
	@Input() infoProjectPhases: any;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	formData: any = {
		'phases': []
	}

	submitForm() {
		this.loading = true;
		let filteredPhases = this.formData.phases.filter(phase => phase.week || phase.date_start);
		this.savePhase(filteredPhases, 0);
	}

	savePhase(filteredPhases, index) {
		this._tS.createPhaseProject(this.project.id, filteredPhases[index]).subscribe(
			(data: any) => {
				if (filteredPhases[index + 1]) {
					this.savePhase(filteredPhases, index + 1);
					return;
				} else {
					this.loading = false;
					this.notify.emit();
				}
			},
			err => {
				this.notify.emit();
			}
		)
	}

	close() {
		this.closeView.emit()
	}

	weekIsRequired(phase) {
		if (phase.phase_id == 2) {
			return this.preProductionFieldIsRequired(phase, 'date_start');
		} else {
			return this.phaseHasOnlyWeeks(phase) ? false : (phase.date_start ? true : false);
		}
	}

	dateIsRequired(phase) {
		if (phase.phase_id == 2) {
			return this.preProductionFieldIsRequired(phase, 'week');
		} else {
			return phase.week ? true : false;
		}
	}

	preProductionFieldIsRequired(phase, field) {
		// pre production is required if exists value for production or post production
		let phaseProd = this.formData.phases.find(ph => ph.phase_id == 3);
		let phasePost = this.formData.phases.find(ph => ph.phase_id == 4);
		return phaseProd.week || phasePost.week ? true : (phase[field] ? true : false);
	}

	phaseHasOnlyWeeks(phase) {
		return phase.phase_id == 3 || phase.phase_id == 4;
	}

	formHasValues() {
		for (const phase of this.formData.phases) {
			if (phase.week || phase.date_start) {
				return true;
			}
		}
		return false;
	}

	fillForm() {
		for (const phase of this.formData.phases) {
			let item = this.project.phases_project.find(pp => pp.phase_id == phase.phase_id);
			if (item) {
				phase.id = item.id;
				phase.phase_id = item.phase_id;
				phase.week = item.week;
				phase.date_start = item.date_start;
			}
		}
	}

	setPhases() {
		let phases = JSON.parse(JSON.stringify(this.infoProjectPhases.phases));
		this.formData.phases = phases.map(phase => {
			phase.phase_id = phase.id;
			phase.id = null;
			return phase;
		});
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService) { }

	ngOnInit() {
	
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.project || changes.infoProjectPhases) {
			this.setPhases();
			if (this.project.phases_project.length) {
				this.fillForm();
			}
		}
	}
}
